import React from 'react';
import { useTranslation } from 'react-i18next';

import ConfirmationDialog from 'shared/molecules/ConfirmationDialog';

import { usePlaylist } from '../../../context';

const DeleteDialog = () => {
  const { t } = useTranslation();

  const {
    dialogs: {
      // Share open variables
      openDeleteDialog,
      // Dialog status
      formStatus,
      // Dialog state variables
      deletePlaylistId,
      removeContentId,
      onDeletePlaylist,
      onDeleteCloseHandler,
      // Content dialog
      removeFromPlaylistHandler,
    },
  } = usePlaylist();

  return (
    <ConfirmationDialog
      open={openDeleteDialog}
      ariaLabel={
        removeContentId
          ? t('playlist.removeFromPlaylist')
          : t('playlist.removePlaylist')
      }
      title={
        removeContentId
          ? t('playlist.removeFromPlaylist')
          : t('playlist.removePlaylist')
      }
      description={t('playlist.areYouSure')}
      cancelText={t('generic.cancel')}
      confirmText={t('generic.delete')}
      onCancel={onDeleteCloseHandler}
      onClose={onDeleteCloseHandler}
      formStatus={formStatus}
      onConfirm={
        removeContentId
          ? () => removeFromPlaylistHandler(removeContentId)
          : () => onDeletePlaylist(deletePlaylistId)
      }
    />
  );
};

export default DeleteDialog;
